// SCRUM-1003: the care plan Height field is recorded in inches instead of
// feet for care plans created on/after this date (PST). Older care plans -
// and their downloads - keep showing feet, since their values were entered
// in feet. Like SYMPTOMS_CHECKBOX_CUTOFF_DATE_PST, this is a FIXED date: set
// it to the day this change ships.
export const HEIGHT_INCHES_CUTOFF_DATE_PST = "2026-11-04";

// A care plan with no created_at yet is a new one, so it uses inches.
export const usesHeightInches = (createdAt) => {
  if (!createdAt) return true;
  const createdDatePST = new Date(createdAt).toLocaleDateString("en-CA", {
    timeZone: "America/Los_Angeles",
  });
  return createdDatePST >= HEIGHT_INCHES_CUTOFF_DATE_PST;
};

export const getHeightUnit = (createdAt) => (usesHeightInches(createdAt) ? "inches" : "feet");
